import { render, staticRenderFns } from "./PriceMapList.vue?vue&type=template&id=706c0252&scoped=true"
import script from "./PriceMapList.vue?vue&type=script&lang=js"
export * from "./PriceMapList.vue?vue&type=script&lang=js"
import style0 from "./PriceMapList.vue?vue&type=style&index=0&id=706c0252&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706c0252",
  null
  
)

export default component.exports